import PropTypes from 'prop-types';
import close from '../../images/icons/circle-x.svg';
import Button from '../buttons/button';

const inputId = 'search-bar-input';

const SearchBar = ({ closeSearch, searchText, setSearchText }) => {
  return (
    <div className="flex flex-row flex-nowrap items-center rounded-sm border border-black/20 bg-white dark:border-white/20 dark:bg-black">
      <label className="px-2" htmlFor={inputId}>
        Search
      </label>
      <input
        aria-label="Search keywords"
        id={inputId}
        onChange={(event) => setSearchText(event.target.value)}
        onKeyDown={(event) => {
          // Escape key
          if (event.keyCode === 27) {
            closeSearch();
          }
        }}
        ref={(input) => input?.focus()}
        type="text"
        value={searchText}
        className="grow border-0 dark:bg-black"
      />
      <Button
        aria-label="Close search"
        onClick={closeSearch}
        iconSrc={close}
        theme="tab"
      >
        Cancel
      </Button>
    </div>
  );
};

SearchBar.propTypes = {
  className: PropTypes.string,
  closeSearch: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
};

export default SearchBar;
